import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getglbfileFailure,
  getglbfileSuccess,
} from "../../actions";
import { GLB_FILE } from "../../Actions/types";
import api from "../../../helper/api";

function* fetchGlbFile(action) {
  try {
    const response = yield api.post("/admin/glb/upload", action?.payload?.form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data);
      yield put(getglbfileSuccess({ getData: response?.data }));
      toast.success(response?.data?.message);
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.message)
    yield put(getglbfileFailure({ getError: e }));
  }
}

function* glbFileWatcher() {
  yield takeLatest(GLB_FILE, fetchGlbFile);
}

export default function* glbFileSaga() {
  yield all([glbFileWatcher()]);
}
